import {useQuery} from "react-query";
import {VesselInspectionResponse} from "../types/responses/VesselInspectionResponse";
import DataRequest from "./DataRequest";
import { LandingData } from "../types/responses/landingData";

export const getVesselInspectionData = (inspectionId: string, user: any) => {
    return useQuery<VesselInspectionResponse & LandingData>("vesselParticulars", async () => {
        const particulars = await DataRequest(inspectionId, "particulars", user);
        const landingData: LandingData = await DataRequest(inspectionId,  "landingData", user);

        return {
            ...particulars,
            ...landingData
        }
    });
}